import { z } from "zod";
import {
  TagSchema,
  createTagSchema,
  updateTagSchema,
} from "@/lib/validations/products/tags";

/** Fields that can be edited in a tag */
export type TagEditableField = "name";

/** Interface defining permissions for tag fields */
export interface TagFieldPermissions {
  editable: TagEditableField[];
  viewable: TagEditableField[];
}

/** Fields that can be used for sorting tags */
export const TagSortable = ["name", "created", "updated"] as const;
export type TagSortField = (typeof TagSortable)[number];

/** Complete tag type with all fields */
export type Tag = z.infer<typeof TagSchema>;

/** Type for creating a new tag */
export type CreateTagInput = z.infer<typeof createTagSchema>;

/** Type for updating an existing tag */
export type UpdateTagInput = z.infer<typeof updateTagSchema>;

/** Tag with relationships */
export interface TagWithRelations extends Tag {
  products?: Array<{
    id: string;
    title: string;
  }>;
}
